export default "__VITE_ASSET__DOO4CRQT__"